import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // No waiting — animation starts immediately.
    // Cards use CSS background as placeholder while images load.
  }
}
